import { i18n } from 'i18next';
import { omit } from 'lodash-es';
import { withTranslation } from 'next-i18next/pages';
import { NextRouter, withRouter } from 'next/router';
import { Component, ReactNode } from 'react';

import { getButtonClassName } from '@pflegia/ui/shared/button';

import { TitleAndDescription } from '../title-and-description/TitleAndDescription.component';

interface ExtendedProps {
  i18n: i18n;
  router: NextRouter;
}

type Props = {
  children: ReactNode;
} & ExtendedProps;

interface State {
  hasError: boolean;
}

/**
 * Error boundary around funnel that shows a button to return to the first step to recover.
 */
class FunnelErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: unknown) {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const {
      children,
      i18n: { t },
      router,
    } = this.props;

    return hasError ? (
      <div>
        <TitleAndDescription title={t('funnel:errorBoundary.title') as string} />
        <button
          className={getButtonClassName('primary', 'mt-3')}
          onClick={async () => {
            const [pathname] = router.asPath.split('?');
            await router.push(
              { pathname: router.pathname, query: omit(router.query, ['id']) },
              { pathname, query: omit(router.query, ['flavor', 'locale', 'id']) },
            );
            this.setState({ hasError: false });
          }}>
          {t('funnel:errorBoundary.retry') as string}
        </button>
      </div>
    ) : (
      children
    );
  }
}

export default withTranslation()(withRouter(FunnelErrorBoundary));
